import { schema } from 'normalizr';

import { processNotification } from '../strategies/notifications';

import { broadcastForNotificationSchema } from './broadcastForNotification';
import { groupSchema } from './group';
import { messageSchema } from './message';
import { teamsMeetingSchema } from './teamsMeeting';
import { threadSchema } from './thread';
import { threadScopeSchema } from './threadScope';
import { userSchema } from './user';
import { userReactionAccentColorsSchema } from './userReactionAccentColors';
import { viewerIsFollowingUserSchema } from './viewerIsFollowingUser';

const notificationDetailsSchema = new schema.Object({
  groupId: groupSchema,
  featuredReactionUserIds: [userReactionAccentColorsSchema],
  markingUserId: userSchema,
  threadId: threadSchema,
  messageId: messageSchema,
  broadcastId: broadcastForNotificationSchema,
  addingUserId: userSchema,
  postingUserId: userSchema,
  onBehalfOfUserId: userSchema,
  requestingUserId: userSchema,
  featuredFollowerUserIds: [userSchema],
  userId: userSchema,
  featuredVotingUserIds: [userSchema],
  featuredUpvotingUserIds: [userSchema],
  wallOwnerId: userSchema,
  scope: threadScopeSchema,
  viewerIsFollowingUsers: [viewerIsFollowingUserSchema],
  teamsMeetingId: teamsMeetingSchema,
});

const notificationSchema = new schema.Entity(
  'notifications',
  { details: notificationDetailsSchema },
  { processStrategy: processNotification }
);

const notificationEdgeSchema = [new schema.Object({ node: notificationSchema })];

export type NotificationPaginationSchema = typeof notificationPaginationsSchema;
export const notificationPaginationsSchema = new schema.Object({
  edges: notificationEdgeSchema,
});
